if (!customElements.get('zone-finder-notification')) {
  customElements.define(
    'zone-finder-notification',
    class ZoneFinderNotification extends HTMLElement {
      // Use the same storage key as the main zone finder
      static STORAGE_KEY = 'zone-finder-data';

      constructor() {
        super();
        
        // Store reference to DOM elements
        this.button = this.querySelector('button');
        this.spanText = this.querySelector('span');
        
        // Store unsubscribe function
        this.unsubscribeZoneUpdate = null;
        
        // Bind event handler
        this.handleZoneUpdate = this.handleZoneUpdate.bind(this);
      }

      connectedCallback() {
        // Subscribe to zone update events
        this.unsubscribeZoneUpdate = subscribe(PUB_SUB_EVENTS.zoneUpdate, this.handleZoneUpdate);
        
        // Load stored data and update display
        this.loadStoredZoneData();
      }

      disconnectedCallback() {
        // Clean up subscription
        if (this.unsubscribeZoneUpdate) {
          this.unsubscribeZoneUpdate();
          this.unsubscribeZoneUpdate = null;
        }
      }

      handleZoneUpdate(eventData) {
        // Update display with new zone data from the event
        if (eventData && eventData.zipCode && eventData.zoneData && eventData.zoneData.success) {
          this.updateZoneDisplay(eventData.zipCode, eventData.zoneData);
        }
      }

      updateZoneDisplay(zipCode, zoneData) {
        // Zone data now contains just the zone number (e.g., "6A")
        const zoneNumber = zoneData.zone;
        
        // Update the button text and add active class
        this.spanText.textContent = `Your Planting Zone: ${zoneNumber} (${zipCode})`;
        this.button.classList.add('active');
        
        // Remove loading shimmer class
        this.button.classList.remove('loading-shimmer');
      }

      loadStoredZoneData() {
        try {
          const storedData = localStorage.getItem(ZoneFinderNotification.STORAGE_KEY);
          if (storedData) {
            const parsedData = JSON.parse(storedData);
            
            // Validate the stored data structure
            if (parsedData.zipCode && parsedData.zoneData && parsedData.zoneData.success) {
              this.updateZoneDisplay(parsedData.zipCode, parsedData.zoneData);
              return true; // Data was loaded successfully
            }
          }
        } catch (error) {
          console.warn('Unable to load stored zone data for notification:', error);
        }
        
        // Always remove loading shimmer class, regardless of outcome
        this.button.classList.remove('loading-shimmer');
        return false; // No data was loaded
      }

      clearStoredZoneData() {
        try {
          localStorage.removeItem(ZoneFinderNotification.STORAGE_KEY);
          // Reset the display
          this.spanText.textContent = 'Find My Planting Zone';
          this.button.classList.remove('active');
        } catch (error) {
          console.warn('Unable to clear stored zone data:', error);
        }
      }
    }
  );
}
